import { render, staticRenderFns } from "./AscDuplicateName.vue?vue&type=template&id=c23a1926&"
import script from "./AscDuplicateName.vue?vue&type=script&lang=js&"
export * from "./AscDuplicateName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports